import { Text } from 'pounceV2';
import React from 'react';
import { useTheme } from '@mui/material';
import RuleErrorTagV3 from './RuleErrorTagV3';
import { getFlowChartColors } from '../../constantsV3';

interface StepInfoProps {
  list?: string[];
  error?: string;
}

const StepInfoV3: React.FC<StepInfoProps> = props => {
  const theme = useTheme();
  const FLOW_CHART_COLORS = getFlowChartColors(theme.palette.tokens);
  const { list, error } = props;
  const listHeading = React.useMemo(() => {
    if (!list) {
      return 'RULE MATCH';
    }

    if (list.length > 1) {
      return `${list[0]} +${list.length - 1}`;
    }

    return list[0];
  }, [list]);

  return error ? (
    <RuleErrorTagV3>{error}</RuleErrorTagV3>
  ) : (
    <>
      <Text as="span" variant="body/sm" color={FLOW_CHART_COLORS.SECONDARY_TEXT}>
        {listHeading}
      </Text>
    </>
  );
};

export default StepInfoV3;
